import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			rootBoxdow: {
				width: 7,
				height: 15,
				"-webkit-transform": "skew(30deg)",
				"-moz-transform": "skew(30deg)",
				"-o-transform": "skew(30deg)",
				transform: "skew(30deg)",
				position: "absolute",
				top: 30,
				left: 0,
				zIndex: 1
			},
			rootPromotion: {
				position: "absolute",
				top: 6,
				left: -5,
				fontSize: 12,
				zIndex: 3,
				color: theme.palette.common.white,
				fontWeight: 700,
				padding: 5,
				borderRadius: "4px 4px 4px 0px"
			}
		}),
	{
		name: "Promotion",
		index: 1
	}
);

export default useStyles;
